export default __webpack_public_path__ + "static/media/submenu-careers.833d319e.jpg";